import { css } from 'styled-components';
import { deviceSizes } from '../../style';

export const widths = {
  'full-screen': '100%',
  '4xl': '95%',
  '3xl': css`
    width: 85%;
    max-width: 1400px;
  `,
  xxl: '1200px',
  xl: '920px',
  lg: '700px',
  md: '496px',
  sm: '370px',
  xs: '288px',
};

export const heights = {
  'full-screen': '100vh',
  xxxl: '95vh',
  xxl: '80vh',
  lg: '600px',
  sm: '276px',
  default: 'auto',
};

// sometimes we want additional styled applied in conjunction with width and height. those are styleModes
export const styleModes = {
  // when we want the modal to be a full screen one we want to add additional styles to make it full screen compatible
  'full-screen': css`
    border-radius: 0;
    box-shadow: none;
    max-height: 100%;

    @media (max-width: ${deviceSizes.sm}) {
      min-width: 100%;
    }
  `,
  // when we want to render a modal that has a fixed footer to the button and a scrollable content above. should be used with Modal.Footer and Modal.ScrollableContent
  'footer-layout': css`
    display: flex;
    flex-direction: column;
  `,
};
